import React, { useState, useEffect, FC } from "react";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { useNavigate, useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { useSelector } from "react-redux";
import dropdownApis from "../../api/WorkOrderManagement/DropdownApis";
import {
  mockWorkExecutionData,
  mockWorkExecutionWidgetData,
  mockWorkExecutionStatusOptions,
  mockContractTypeOptions,
  mockSiteOptions,
  mockWorkOrderOwnerOptions,
} from "./mockData/workExecutionData";
import { WorkExecutionData, WorkExecutionStatus } from "./types";
import WorkExecutionAside from "./workExecutionAside";
import {
  Drawer,
  Button,
  Badge,
  Select,
  Input,
  DatePicker,
  Form,
  Row,
  Col,
  Space,
  Divider,
  Tag,
} from "antd";
import {
  FilterOutlined,
  SearchOutlined,
  ReloadOutlined,
  SaveOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Option } = Select;

interface FilterState {
  workOrderNumber?: string;
  workOrderTitle?: string;
  status?: string[];
  siteId?: string[];
  contractorName?: string[];
  workOrderId?: string[];
  contractType?: string[];
  executionDateRange?: [any, any] | null;
  progressRange?: { min?: number; max?: number };
  executedValueRange?: { min?: number; max?: number };
  workOrderOwner?: string;
}

const UnderWorkExecution: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const flowType = searchParams.get("flowType");
  const isClientFlow = flowType?.toLowerCase() === "client";
  const [sm, setSm] = useState(false);
  const [widgetData, setWidgetData] = useState<any>({});
  const [executionStatusOptions, setExecutionStatusOptions] = useState<any>([]);
  const [contractorOptions, setContractorOptions] = useState<any>([]);
  const [contractTypeOptions, setContractTypeOptions] = useState<any>([]);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [workOrderOwnerOptions, setWorkOrderOwnerOptions] = useState<any>([]);
  const [workOrderOptions, setWorkOrderOptions] = useState<any[]>([]);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [selectedKPIFilter, setSelectedKPIFilter] = useState<string>("status");
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  const [filters, setFilters] = useState<FilterState>({});
  const [tempFilters, setTempFilters] = useState<FilterState>({});
  const [savedFilters, setSavedFilters] = useState<{
    [key: string]: FilterState;
  }>({});
  const [form] = Form.useForm();
  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (Array.isArray(value) && value.length > 0) count++;
        else if (typeof value === "object" && value !== null) {
          if ("min" in value && value.min !== undefined) count++;
          if ("max" in value && value.max !== undefined) count++;
        } else if (typeof value === "string" && value.trim() !== "") count++;
      }
    });
    return count;
  };

  const calculateAge = (releasedDate: string) => {
    const today = new Date();
    const released = new Date(releasedDate);
    const diffTime = today.getTime() - released.getTime();
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  };

  const columns = [
    {
      title: "WO #",
      dataIndex: "workOrderNumber",
      key: "workOrderNumber",
      width: 220,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`woExecution-${record?.workOrderId}`}
              onClick={() => {
                const searchParams = new URLSearchParams(location.search);
                const flowType = searchParams.get("flowType");
                const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";
                navigate(
                  `/work-order-view/${record.workOrderId}${flowTypeQuery}`
                );
              }}
            >
              {text}
            </span>
            {/* <TooltipComponent
              iconClass="info-circle text-info"
              icon="info"
              id={`woExecution-${record?.id}`}
              direction="right"
              text="Click To View Work Order Details"
              containerClassName={"mt-1"}
            /> */}
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "workOrderTitle",
      key: "workOrderTitle",
      width: 240,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`title-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 30)}... ` : text}
            </span>
            {/* {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`title-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )} */}
          </>
        );
      },
    },
    {
      title: "Site/Project",
      key: "siteProject",
      width: 180,
      render: (text: any, record: any) => (
        <div>
          <div className="fw-bold">{record.siteName}</div>
          <div className="text-muted small">{record.projectName || "N/A"}</div>
        </div>
      ),
    },
    {
      title: isClientFlow ? "Client" : "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 200,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`contractor-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 20)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`contractor-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Released On",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 180,
      render: (date: any) => <span>{date ? FormatDate(date) : "---"}</span>,
    },
    {
      title: "Progress %",
      key: "progressPercent",
      width: 100,
      render: (text: any, record: any) => {
        const progress = record.progressPercent;
        return (
          <div style={{ textAlign: "center" }}>
            <span
              className={`badge ${
                progress > 75
                  ? "bg-success"
                  : progress > 50
                  ? "bg-info"
                  : progress < 25
                  ? "bg-warning"
                  : "bg-secondary"
              }`}
            >
              {progress}%
            </span>
          </div>
        );
      },
    },
    {
      title: "Last Exec Update",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 190,
      render: (date: any) => <span>{date ? FormatDate(date) : "---"}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 220,
      fixed: "right",
      render: (status: any) => {
        const getStatusColor = () => {
          switch (status) {
            case "Pending Execution Approval":
              return "blue";
            case "In Execution":
              return "orange";
            default:
              return "default";
          }
        };

        return <Tag color={getStatusColor()}>{status}</Tag>;
      },
    },
    // {
    //   title: "Age (Days)",
    //   key: "age",
    //   width: 100,
    //   render: (text: any, record: any) => {
    //     const age = record.releasedOn ? calculateAge(record.releasedOn) : 0;
    //     return (
    //       <div style={{ textAlign: "center" }}>
    //         <span
    //           // className={`badge ${
    //           //   5 > 30
    //           //     ? "bg-danger"
    //           //     : 5 > 15
    //           //     ? "bg-warning"
    //           //     : 5 > 7
    //           //     ? "bg-info"
    //           //     : "bg-success"
    //           // }`}
    //         >
    //           {5}
    //         </span>
    //       </div>
    //     );
    //   },
    // },
  ];

  // Filter Functions
  const handleFilterDrawerOpen = async () => {
    setTempFilters({ ...filters });
    form.setFieldsValue(filters);
    setFilterDrawerVisible(true);

    // Fetch dropdown data when drawer opens
    try {
      const flowTypeParam = isClientFlow ? "Client" : "Contractor";

      // Fetch contractors
      const partyType = isClientFlow ? "Client" : "Contractor";
      const contractorsResponse = await dropdownApis.fetchContractorDropDown(
        partyType
      );
      if (
        contractorsResponse &&
        contractorsResponse.status &&
        contractorsResponse.data
      ) {
        const contractorOptions = contractorsResponse.data.map((item: any) => ({
          label: item.companyName || "N/A",
          value: item.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }

      // Fetch work orders
      const workOrdersResponse = await dropdownApis.fetchWorkOrderDropdown(
        flowTypeParam
      );
      if (
        workOrdersResponse &&
        workOrdersResponse.status &&
        workOrdersResponse.data
      ) {
        const workOrderOptions = workOrdersResponse.data.map((item: any) => {
          const label =
            item.workOrderNumber ||
            item.workOrderSequenceId ||
            item.sequenceId ||
            item.workOrderTitle ||
            `WO-${item.workOrderId || item.id || "N/A"}`;
          const value = item.workOrderId?.toString() || item.id?.toString();
          return { label, value };
        });
        setWorkOrderOptions(workOrderOptions);
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const handleFilterDrawerClose = () => {
    setFilterDrawerVisible(false);
    setTempFilters({});
    form.resetFields();
  };

  const handleApplyFilters = () => {
    form
      .validateFields()
      .then((values) => {
        const processedFilters: FilterState = {
          workOrderNumber: values.workOrderNumber?.trim() || undefined,
          workOrderTitle: values.workOrderTitle?.trim() || undefined,
          status:
            values.status && values.status.length > 0
              ? values.status
              : undefined,
          siteId:
            values.siteId && values.siteId.length > 0
              ? values.siteId
              : undefined,
          contractorName:
            values.contractorName && values.contractorName.length > 0
              ? values.contractorName
              : undefined,
          workOrderId:
            values.workOrderId && values.workOrderId.length > 0
              ? values.workOrderId
              : undefined,
          contractType:
            values.contractType && values.contractType.length > 0
              ? values.contractType
              : undefined,
          executionDateRange: values.executionDateRange || undefined,
          progressRange: {
            min: values.progressMin || undefined,
            max: values.progressMax || undefined,
          },
          executedValueRange: {
            min: values.executedValueMin || undefined,
            max: values.executedValueMax || undefined,
          },
          workOrderOwner: values.workOrderOwner?.trim() || undefined,
        };

        Object.keys(processedFilters).forEach((key) => {
          if (processedFilters[key as keyof FilterState] === undefined) {
            delete processedFilters[key as keyof FilterState];
          }
        });

        if (
          processedFilters.progressRange &&
          !processedFilters.progressRange.min &&
          !processedFilters.progressRange.max
        ) {
          delete processedFilters.progressRange;
        }

        if (
          processedFilters.executedValueRange &&
          !processedFilters.executedValueRange.min &&
          !processedFilters.executedValueRange.max
        ) {
          delete processedFilters.executedValueRange;
        }

        setFilters(processedFilters);
        setFilterDrawerVisible(false);
      })
      .catch((error) => {
        console.error("Form validation failed:", error);
      });
  };

  const handleResetFilters = () => {
    setFilters({});
    setTempFilters({});
    form.resetFields();
  };

  const handleSaveFilter = () => {
    const filterName = prompt("Enter a name for this filter:");
    if (filterName && filterName.trim()) {
      setSavedFilters((prev) => ({
        ...prev,
        [filterName.trim()]: { ...filters },
      }));
    }
  };

  const handleLoadFilter = (filterName: string) => {
    const savedFilter = savedFilters[filterName];
    if (savedFilter) {
      setFilters(savedFilter);
      setTempFilters(savedFilter);
      form.setFieldsValue(savedFilter);
    }
  };

  useEffect(() => {
    // Load mock data
    setWidgetData(mockWorkExecutionWidgetData);
    setExecutionStatusOptions(mockWorkExecutionStatusOptions);
    setContractTypeOptions(mockContractTypeOptions);
    setSiteOptions(mockSiteOptions);
    setWorkOrderOwnerOptions(mockWorkOrderOwnerOptions);
  }, []);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const _siteOptions: any = [];
        siteAccessibility?.forEach((item: any) => {
          _siteOptions.push({ label: item.siteName, value: item.siteID });
        });
        setSiteOptions([..._siteOptions]);
      }
    }
  }, [currentUser]);

  // KPI Filter Change Handler
  const handleKPIFilterChange = (filterValue: string) => {
    setSelectedKPIFilter(filterValue);
  };

  // Filter data to show only active executions (In Progress, On Hold, Not Started)
  const filteredData = mockWorkExecutionData.filter((item) =>
    [
      WorkExecutionStatus.InProgress,
      WorkExecutionStatus.OnHold,
      WorkExecutionStatus.NotStarted,
    ].includes(item.status)
  );

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="under-work-execution"
        title="Under Work Execution"
        columns={columns}
        data={filteredData}
        customFilters={filters}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
              sm ? "content-active" : ""
            }`}
          >
            <WorkExecutionAside updateSm={setSm} sm={sm} />
          </div>
        }
        topRightJSX={
          <Space>
            <Badge count={getActiveFilterCount()} size="small">
              <Button
                type="primary"
                icon={<FilterOutlined />}
                onClick={handleFilterDrawerOpen}
              >
                Advanced Filters
              </Button>
            </Badge>
          </Space>
        }
        extra={{
          tableScrollX: 1350,
          dateRange: false,
          excelExport: true,
          dataFilterTootip: "Filtering based on Work Execution date",
        }}
      />

      <Drawer
        title="Advanced Filters"
        width={420}
        open={filterDrawerVisible}
        onClose={handleFilterDrawerClose}
        extra={
          <Space size="middle">
            <Badge count={getActiveFilterCount()} size="small">
              <Button size="small" type="text" icon={<FilterOutlined />} />
            </Badge>
            <Button
              size="small"
              onClick={handleResetFilters}
              icon={<ReloadOutlined />}
            >
              Reset
            </Button>
          </Space>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space>
              <Button
                size="small"
                onClick={handleSaveFilter}
                icon={<SaveOutlined />}
              >
                Save Filter
              </Button>
              {Object.keys(savedFilters).length > 0 && (
                <Select
                  placeholder="Load saved filter"
                  size="small"
                  style={{ width: 150 }}
                  suffixIcon={<FolderOpenOutlined />}
                  onChange={handleLoadFilter}
                  allowClear
                >
                  {Object.keys(savedFilters).map((filterName) => (
                    <Option key={filterName} value={filterName}>
                      {filterName}
                    </Option>
                  ))}
                </Select>
              )}
            </Space>
            <Space>
              <Button onClick={handleFilterDrawerClose}>Cancel</Button>
              <Button
                type="primary"
                onClick={handleApplyFilters}
                icon={<SearchOutlined />}
              >
                Apply Filters
              </Button>
            </Space>
          </div>
        }
      >
        <Form form={form} layout="vertical" initialValues={filters}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item name="siteId" label="Site/Project">
                <Select
                  mode="multiple"
                  placeholder="Select Sites"
                  options={siteOptions}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                name="contractorName"
                label={isClientFlow ? "Client" : "Contractor"}
              >
                <Select
                  mode="multiple"
                  placeholder={
                    isClientFlow ? "Select Clients" : "Select Contractors"
                  }
                  options={contractorOptions}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="workOrderId" label="Work Order Number">
                <Select
                  mode="multiple"
                  placeholder="Select Work Orders"
                  options={workOrderOptions}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default UnderWorkExecution;
